<template>
  <p :class="['c-remark', theme]">
    <slot/>
  </p>
</template>

<script setup lang="ts">
  import { computed } from 'vue';

  export type Theme = 'info' | 'danger';

  const props = withDefaults(defineProps<{
    theme?: Theme
  }>(), {
    theme: 'info',
  });

  const theme = computed(() => {
    switch (props.theme) {
      case 'info':
        return 'c-remark-info';
      case 'danger':
        return 'c-remark-danger';
      default:
        return '';
    }
  });
</script>

<style lang="scss">
  .c-remark {
    font-style: italic;
  }

  .c-remark-info {
    color: $neutral-600;
  }

  .c-remark-danger {
    color: $danger-600;
  }
</style>